<template>
    <div class="container" :style="cssProps">
        <alert ref="alert"></alert>
        <h1>Schedule my order</h1>
        <h2>Select a delivery time up to 7 days in advance.</h2>
        <div class="d-flex flex-row">
            <h3>Choose Method</h3>
            <!-- <div class="link_clear d-flex" v-if="choosedMethod">
                <a href="#" @click.prevent="clear">Clear Method</a>
            </div> -->
        </div>
        <div class="container-method d-flex flex-row ">
            <button type="button" class="d-flex flex-column justify-content-between align-items-start" 
                @click="chooseMethod('pickup')" :class="[choosedMethod === 'pickup'? 'active' : '']">
                <i class="fa-hand-receiving" :class="[choosedMethod === 'pickup'? 'fas' : 'fal']"></i>
                <span>Carryout</span>
            </button>
            <button type="button" class="d-flex flex-column justify-content-between align-items-start" 
                @click="chooseMethod('curbside')" :class="[choosedMethod === 'curbside'? 'active' : '']">
                <i class="fa-person-carry" :class="[choosedMethod === 'curbside'? 'fas' : 'fal']"></i>
                <span>Curbside Pickup</span>
            </button>
            <button type="button" class="d-flex flex-column justify-content-between align-items-start" 
            @click="chooseMethod('delivery')" :class="[choosedMethod === 'delivery' ? 'active' : '']">
                <i class="fa-shipping-fast" :class="[choosedMethod === 'delivery' ? 'fas' : 'fal']"></i>
                <span>Delivery</span>
            </button>
            <!-- <button type="button" class="d-flex flex-column justify-content-between align-items-start" v-if="info.restaurant.supportsdinein" @click="chooseMethod('dinein')">
                <i class="fal fa-concierge-bell"></i>
                <span>Dine-In</span>
            </button> -->
            <button type="button" class="d-flex flex-column justify-content-between align-items-start" 
            @click="chooseMethod('drivethru')" :class="[choosedMethod === 'drivethru'? 'active' : '']">
                <i class="fa-car" :class="[choosedMethod === 'drivethru'? 'fas' : 'fal']"></i>
                <span>Drive-Through</span>
            </button>
        </div>
        <div >
            <h3>When</h3>
            <div class="container-method d-flex flex-row">
                <button type="button" class="d-flex flex-column justify-content-between align-items-start" 
                    @click="chooseWhen('asap')" :class="[choosedWhen === 'asap'? 'active' : '']">
                    <i class="fa-bell" :class="[choosedWhen === 'asap'? 'fas' : 'fal']"></i>
                    <span>ASAP</span>
                    <span class="later" v-if="choosedWhen === 'asap'">{{asap}} minutes</span>
                </button>
                <button type="button" class="d-flex flex-column justify-content-between align-items-start" 
                    @click="chooseWhen('today')" :class="[choosedWhen === 'today'? 'active' : '']">
                    <i class="fa-calendar-check" :class="[choosedWhen === 'today'? 'fas' : 'fal']"></i>
                    <span>Today</span>
                    <span class="later" v-if="choosedWhen === 'today'">{{stringDate}}</span>
                </button>
                <button type="button" class="d-flex flex-column justify-content-between align-items-start" 
                    @click="chooseWhen('later')" :class="[choosedWhen === 'later'? 'active' : '']">
                    <i class="fa-calendar-alt" :class="[choosedWhen === 'later'? 'fas' : 'fal']"></i>
                    <span >Later</span>
                    <span class="later" v-if="choosedWhen === 'later'">{{stringDate}}</span>
                </button>
            </div>
        </div>
        <div class="container-button d-flex flex-row align-items-center">
            <button type="button" class="btn-cont" @click="order">
                <span>Continue</span>
            </button>
             <div class="modify_link d-flex" >
            <a href="#" @click.prevent="clear">Clear selected</a>
            </div>
        </div>
        <datemodal ref="datemodal" @submit="saveWhen"></datemodal>
        <addressmodal ref="addressmodal" @submit="saveAddress"></addressmodal>
        <selectadress ref="selectadress"></selectadress>
    </div>
    
</template>
<script>
import axios from "axios";
import { mapState } from 'vuex';
import dateModal from './modals/dateModal.vue'
import addressModal from './modals/addressModal.vue'
import selectAdress from './modals/selectAdress.vue'
import alert from './custom/alert.vue'
export default {
    name: 'schedule',
    components: {
        alert,
        datemodal: dateModal,
        addressmodal: addressModal,
        selectadress: selectAdress
    },
    data(){
        return{
            choosedMethod: 'pickup',
            choosedWhen: 'asap',
            choosedAddress: null,
            stringDate: ''
        }
    },
    computed: {
        ...mapState(['info']),
        asap: function(){
            // let today = new Date();
            // let tmp = this.info.basket.earliestreadytime;
            // tmp = tmp.slice(0, 4) + "/" + tmp.slice(4, 6) + "/" + tmp.slice(6, 8) + " " + tmp.slice(9) + ":00";
            // var diff = Math.abs(new Date() - new Date(tmp));
            // return Math.floor(diff / 1000 / 60);
            return '15 - 20';
        },
        cssProps() { return {
        '--main-color': this.info.color ? "#" + this.info.color : "#c12d39"
      }
    }
    },
    methods:{
        modalAddress()
        {
            this.$refs.addressmodal.show()
        },
        saveAddress(deliveryInfo){
            this.$store.commit("address.add", {address: deliveryInfo});
            this.choosedAddress = this.info.savedDeliveryAddresses.length - 1;
            this.$store.commit("address.set", {index: this.info.savedDeliveryAddresses.length - 1});
        },
        chooseAddress(index){
            this.choosedAddress = index;
            this.$store.commit("address.set", {index});
        },
        chooseMethod(method){
           this.$store.commit("method.set", { method });
           this.choosedMethod = method;
           if(this.choosedMethod === "delivery"){
               //call modal
               this.$refs.selectadress.show();
           }
        },
        chooseWhen(when){
            this.choosedWhen = when;
            this.stringDate = null;
            this.$store.commit("when.set", {when: this.choosedWhen});
            if(this.choosedWhen !== 'asap'){
                this.$refs.datemodal.show();
            }
        },
        saveWhen(deliveryDate, stringDate){
            this.stringDate = stringDate;
            this.$store.commit("date.set", {deliveryDate});
        },
        async order() {
            //save to busket
            //check busket id ?
            //check if everything is finished
            let thisRef = this;
            let hasErrors = false;
            if(this.info.method && this.info.when){
                if(this.info.method === "delivery"){
                    if(!this.info.savedDeliveryAddresses[this.info.choosedAddressIndex]){
                        //no address
                        hasErrors = true;
                        this.$refs.alert.message = "No chosen address";
                        this.$refs.alert.show();
                    }
                }
                if(this.info.when !== "asap" && !this.info.deliveryDate){
                    //no date for later
                    hasErrors = true;
                    this.$refs.alert.message = "No chosen date and time";
                    this.$refs.alert.show();
                }
                if(!hasErrors){
                    this.$router.push({ name: "search"});
                }
            }
            else{
                this.$refs.alert.message = "No chosen delivery method or date and time";
                this.$refs.alert.show();
            }
             
        },
        clear(){
            this.$store.commit("method.set", { method: null });
            this.$store.commit("when.set", {when: null});
            this.$store.commit("date.set", {deliveryDate: null});
            this.choosedMethod = null;
            this.choosedWhen = null;
            this.stringDate = null;
        },
    },
    mounted(){
        if(this.info.method){ this.choosedMethod = this.info.method; }
        if(this.info.when){ this.choosedWhen = this.info.when; }
    }
}
</script>
<style lang="scss" scoped>
@import '../GlobalStyle/Variables.scss';
.newAdress 
{
    width: 240px !important;
    height: 144px !important;
    margin-left:8px !important;
    
}
.newAdress span:first-child{
    font-size: 16px !important;

}
.newAdress span{
    font-size: 13px;
}


button
{
     border: none;
  padding: 0;
  background: none;
  outline: none;
}
.container
{
    padding: 47px
}
.container h1
{
    text-transform:uppercase;
	opacity: 0.8;
	color: #000000;
	font-family: Poppins;
	font-size: 24px;
	font-weight: 800;
	line-height: 35px;

}
.container h2
{
 
	opacity: 0.4;
	color: #000000;
	font-family: Poppins;
	font-size: 16px;
	line-height: 20px;
}
.container h3
{
    padding-top: 48px;
	opacity: 0.8;
	color: #000000;
	font-family: Poppins;
	font-size: 16px;
	font-weight: bold;
	line-height: 25px;
}
.container-method
{
    padding-top:24px;
}
.container-method button
{
    
	height: 112px;
	width: 158px;
	border: 1px solid rgba(0,0,0,0.1);
	border-radius: 16px;
	background-color: #FFFFFF;
    margin-left: 8px;
    padding: 24px;

}
.container-method button:first-child
{
    
	height: 112px;
	width: 158px;
	border: 1px solid rgba(0,0,0,0.1);
	border-radius: 16px;
	background-color: #FFFFFF;
    margin-left: 0px;

}
.container-method button i{
    
	opacity: 0.8;
	color: #000000;
	font-family: "Font Awesome 5 Pro";
	font-size: 20px;
	// font-weight: 300;
	line-height: 21px;
}
.container-method button span{
    
	opacity: 0.8;
	color: #000000;
	font-family: Poppins;
	font-size: 13px;
	font-weight: bold;
	line-height: 20px;
    white-space: nowrap;    
}

.later
{

	color: #000000;
	font-family: Poppins;
	font-size: 11px !important;
	font-weight: 500 !important;
	line-height: 0px !important;
}
.container-button
{
    padding-top: 48px;
    width: 100%;
}
.btn-cont
{
    
	height: 48px;
	width: 201px;
	border-radius: 24px;
	background-color: var(--main-color);

}
.btn-cont span{
  
	color: #FFFFFF;
	font-family: Poppins;
	font-size: 13px;
	font-weight: 500;
	line-height: 20px;

}
.modify_link {
  /* width: 10%; */
  padding-left: 32px;
}
.modify_link a {
  opacity: 0.4;
  color: #000000;
  font-family: Poppins;
  font-size: 12px;
  font-weight: 500;
  line-height: 25px;
  text-align: right;
  text-decoration: underline;
    white-space: nowrap;
}
.link_clear{
    padding-left: 10%;
}
.link_clear a{
    opacity: 0.4;
    color: #000000;
    font-family: Poppins;
    font-size: 12px;
    font-weight: 500;
    line-height: 25px;
    text-align: right;
    text-decoration: underline;
    white-space: nowrap;
    padding-top: 48px;
}
.active
{
    background-color: var(--main-color) !important;
}
.active i
{
    opacity: 1 !important;
    color:#FFFFFF !important;

}
.active span
{
    opacity: 1 !important;
    color: #FFFFFF !important;
}
.container-method button:hover
{
    background-color:var(--main-color) !important;
}
.container-method button:hover i{
    color:#FFFFFF;
}
.container-method button:hover span{
    color:#FFFFFF;
}

@media screen and (max-width: 600px) {
    .order-block
    {
        display: none !important;
    }
    .container
    {
        width: 100%;
        padding: 15px;
    }
    .container-method
    {
        flex-direction: column !important;
        justify-content: center !important;
        align-items: center !important;
        
    }
    .container-method button
    {
       margin-top: 8px !important;
    width: 100% !important;
    margin-bottom: 0 !important;
    margin-left: 0;
    }
    .newAdress
    {
        width: 100% !important;
    }
    .newA{
        width: 100%;
    }
    .container h1 
    {
        text-align: center;
    }
    .container h2{
        text-align: center;
    }
    .container-button
    {
        flex-direction: column !important;
        margin-bottom: 80px;
    }
    .container-button .btn-cont
    {
        width: 100%;
    }
    .modify_link 
    {
        padding-top: 15px !important;
        padding-left: 0!important;
    }

    
}
</style>


// WEBPACK FOOTER //
// src/components/steps/schedule.vue